module.exports = __webpack_public_path__ + "img/2B.53d93d7d.jpg";